module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Pesquisar Projetos'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pesquisar()
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Número",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.pesquisa.numero),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "numero", $$v)
      },
      expression: "pesquisa.numero"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm9": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Título",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.pesquisa.titulo),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "titulo", $$v)
      },
      expression: "pesquisa.titulo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Classificação Primária",
      "items": _vm.listaTipo,
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "readonly": "",
      "autocomplete": ""
    },
    model: {
      value: (_vm.pesquisa.tipoProjeto),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "tipoProjeto", $$v)
      },
      expression: "pesquisa.tipoProjeto"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Classificação Secundária",
      "items": _vm.listaSubtipo,
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.subtipoProjeto),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "subtipoProjeto", $$v)
      },
      expression: "pesquisa.subtipoProjeto"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.pesquisa.palavraChave),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "palavraChave", $$v)
      },
      expression: "pesquisa.palavraChave"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Membro da equipe",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.pesquisa.membroEquipe),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "membroEquipe", $$v)
      },
      expression: "pesquisa.membroEquipe"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [(_vm.administrador === true || _vm.usuarioPROEX === true) ? _c('v-select', {
    attrs: {
      "label": "Situação",
      "items": _vm.listaSituacao,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.situacao),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "situacao", $$v)
      },
      expression: "pesquisa.situacao"
    }
  }) : _c('v-select', {
    attrs: {
      "label": "Situação",
      "items": _vm.listaSituacao2,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.situacao),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "situacao", $$v)
      },
      expression: "pesquisa.situacao"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Função do membro da equipe",
      "items": _vm.listaFuncaoParticipante,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.funcaoParticipante),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "funcaoParticipante", $$v)
      },
      expression: "pesquisa.funcaoParticipante"
    }
  })], 1)], 1), _vm._v(" "), (_vm.pesquisaAvancada) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Pesquisa ampliada",
      "max-height": "400",
      "hint": "A pesquisa é realizada nos campos Título, Palavras-chave, Resumo, Apresentação, Justificativa, Caracterização do público-alvo, Objetivo geral, Objetivos específicos, Metodologia, Forma de avaliação, Infraestrutura física e Informações adicionais.",
      "persistent-hint": "",
      "clearable": ""
    },
    model: {
      value: (_vm.pesquisa.multiplosCampos),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "multiplosCampos", $$v)
      },
      expression: "pesquisa.multiplosCampos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), (_vm.pesquisaAvancada) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Unidade",
      "items": _vm.listaUnidades,
      "eager": "",
      "item-text": "nomeSigla",
      "item-value": "id",
      "prepend-icon": "account_balance",
      "max-height": "400",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.unidade),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "unidade", $$v)
      },
      expression: "pesquisa.unidade"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo de público-alvo",
      "items": _vm.listaTipoPublico,
      "eager": "",
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "people",
      "max-height": "400",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.tipoPublico),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "tipoPublico", $$v)
      },
      expression: "pesquisa.tipoPublico"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pesquisaAvancada && _vm.pesquisa.unidade) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Consulta simples por unidade  ")]), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-icon', _vm._g(_vm._b({}, 'v-icon', attrs, false), on), [_vm._v("info")])]
            }
          }], null, false, 3628108049)
        }, [_vm._v(" "), _c('span', [_vm._v("Na consulta simples, são retornadas apenas as ações de extensão que estão imediatamente vinculadas à unidade selecionada.")])])]
      },
      proxy: true
    }], null, false, 1596774693),
    model: {
      value: (_vm.simples),
      callback: function($$v) {
        _vm.simples = $$v
      },
      expression: "simples"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pesquisaAvancada) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Principal Área Temática de Extensão",
      "items": _vm.listaAreaTematica,
      "eager": "",
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.principalAreaTematicaExtensao),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "principalAreaTematicaExtensao", $$v)
      },
      expression: "pesquisa.principalAreaTematicaExtensao"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Área Temática de Extensão Afim",
      "items": _vm.listaAreaTematicaAfim.slice(1),
      "eager": "",
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.areaTematicaExtensaoAfim),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "areaTematicaExtensaoAfim", $$v)
      },
      expression: "pesquisa.areaTematicaExtensaoAfim"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pesquisaAvancada) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Linha de Extensão",
      "items": _vm.listaLinhaExtensao,
      "eager": "",
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.linhaExtensao),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "linhaExtensao", $$v)
      },
      expression: "pesquisa.linhaExtensao"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Grande Área do Conhecimento",
      "items": _vm.listaGrandeArea,
      "eager": "",
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.grandeAreaConhecimento),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "grandeAreaConhecimento", $$v)
      },
      expression: "pesquisa.grandeAreaConhecimento"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pesquisaAvancada) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('v-select', {
    attrs: {
      "label": "Principal Objetivo de Desenvolvimento Sustentável",
      "items": _vm.listaODS.slice(0, 17),
      "eager": "",
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.principalObjetivoDesenvolvimentoSustentavel),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "principalObjetivoDesenvolvimentoSustentavel", $$v)
      },
      expression: "pesquisa.principalObjetivoDesenvolvimentoSustentavel"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pesquisaAvancada) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('v-select', {
    attrs: {
      "label": "Objetivo de Desenvolvimento Sustentável Afim",
      "items": _vm.listaODSAfim.slice(0, 17),
      "eager": "",
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.objetivoDesenvolvimentoSustentavelAfim),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "objetivoDesenvolvimentoSustentavelAfim", $$v)
      },
      expression: "pesquisa.objetivoDesenvolvimentoSustentavelAfim"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pesquisaAvancada) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Período - Início",
      "clearable": ""
    },
    model: {
      value: (_vm.pesquisa.periodoInicio),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "periodoInicio", $$v)
      },
      expression: "pesquisa.periodoInicio"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Período - Término",
      "clearable": ""
    },
    model: {
      value: (_vm.pesquisa.periodoTermino),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "periodoTermino", $$v)
      },
      expression: "pesquisa.periodoTermino"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [(!_vm.pesquisaAvancada) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.abrirPesquisaAvancada
    }
  }, [_vm._v("Pesquisa avançada")]) : _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.fecharPesquisaAvancada
    }
  }, [_vm._v("Pesquisa simples")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding-top": "15px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.limpar
    }
  }, [_vm._v("Limpar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.pesquisar
    }
  }, [_vm._v("Pesquisar")])], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Resultados da Pesquisa'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaProjetos,
      "search": _vm.search,
      "no-data-text": 'Nenhum projeto encontrado',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.titulo",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "target": "_blank",
            "to": {
              name: 'ProjetoFormulario',
              params: {
                idProjeto: props.item.idProjeto
              }
            }
          }
        }, [_vm._v(_vm._s(props.item.titulo))])]
      }
    }, {
      key: "item.nomeUnidade",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.unidade.format(props.item.nomeUnidade, props.item.siglaUnidade)))]
      }
    }, {
      key: "item.dataInicio",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicio)))]
      }
    }, {
      key: "item.dataConclusao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataConclusao)))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaProjetos.length) + " projetos\n            ")]
      }
    }])
  }), _vm._v(" "), _c('br')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-751b4250","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/consulta-projetos/consulta-projetos.vue
// module id = 408
// module chunks = 0